import React, { useState, useEffect } from 'react';
import { isTauri } from '../utils/tauri';
import { BellOff, X } from 'lucide-react';

type NotificationIssue = 'windows' | 'web' | null;

export const NotificationSettingsGuide: React.FC = () => {
  const [issue, setIssue] = useState<NotificationIssue>(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    checkNotificationStatus();
  }, []);

  const checkNotificationStatus = async () => {
    if (isTauri()) {
      try {
        const { invoke } = await import('@tauri-apps/api/core');
        const enabled = await invoke<boolean>('check_windows_notifications_enabled');
        if (!enabled) setIssue('windows');
      } catch (e) {
        console.warn('Notification check failed:', e);
      }
    } else {
      if ('Notification' in window && Notification.permission === 'denied') {
        setIssue('web');
      }
    }
    setLoading(false);
  };

  const handleOpenSettings = async () => {
    if (issue === 'windows') {
      try {
        const { invoke } = await import('@tauri-apps/api/core');
        await invoke('open_notification_settings');
      } catch (e) {
        console.error('Failed to open notification settings:', e);
      }
    }
  };

  if (loading || !issue || dismissed) return null;

  return (
    <div
      className="fixed top-9 right-4 z-50 w-80 rounded-lg shadow-lg border overflow-hidden"
      style={{ animation: 'slideDown 0.3s ease-out' }}
    >
      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div className="bg-amber-50 border-amber-200 px-4 py-3">
        <div className="flex items-start justify-between mb-2">
          <div className="flex items-center gap-2">
            <BellOff size={18} className="text-amber-500 shrink-0" />
            <span className="text-sm font-semibold text-gray-900">알림 설정 안내</span>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="p-2 -m-1.5 rounded-lg hover:bg-black/10 transition-colors shrink-0 text-gray-400 hover:text-gray-600"
            title="닫기"
          >
            <X size={14} />
          </button>
        </div>

        <div className="text-sm text-gray-600">
          <p className="mb-3">
            {issue === 'windows'
              ? '윈도우 알림이 꺼져 있어 메시지 알림을 받을 수 없습니다.'
              : '브라우저 알림이 차단되어 메시지 알림을 받을 수 없습니다.'}
          </p>
          {issue === 'windows' ? (
            <button
              onClick={handleOpenSettings}
              className="w-full px-3 py-2 bg-amber-500 text-white rounded-md text-sm font-medium hover:bg-amber-600 transition-colors"
            >
              알림 설정 열기
            </button>
          ) : (
            <p className="text-xs text-gray-500">
              브라우저 주소창 왼쪽의 자물쇠 아이콘을 클릭하여 알림을 허용해주세요.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
